module.exports = __webpack_public_path__ + "img/plus.6050ee71.svg";